import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";

import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "src/app/features/auth/services/auth.service";
import { Policy } from "../../models/policy.interface";
import { PolicyApiService } from "../../services/policy-api.service";
import { TranslateService } from "@ngx-translate/core";
import { TranslationService } from "src/app/core/services/translation.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrl: "./footer.component.scss",
  standalone: false,
})
export class FooterComponent implements OnInit {
  pageSize = 10;
  pageIndex = 0;
  policies: Policy[] = [];
  subscribeForm: FormGroup;
  isSubmitting = false;
  currentUrl = "";
  isLoggedIn$!: Observable<boolean>;
  vendorBaseUrl: string = environment.vendorRegisterUrl;
  normalUserPageUrl: string = environment.normalUserPageUrl;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private policyService: PolicyApiService,
    private translate: TranslateService,
    public translationService: TranslationService
  ) {
    this.subscribeForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
    });
    this.currentUrl = this.router.url;
  }

ngOnInit() {
  this.isLoggedIn$ = this.authService.isLoggedIn();

  this.policyService.getAllPolicies().subscribe(res => {
    if (res?.success) {
      const internalKeyPrefixes = ['POL-'];

      const hardcodedKeys = ['RegistrationPolicy', 'INFOPRIVACYPOLICY', 'DISPUTERESOLUTION'];

      this.policies = res.data.filter(policy =>
        policy.isActive &&
        !hardcodedKeys.includes(policy.privacyKey) &&
        !internalKeyPrefixes.some(prefix => policy.privacyKey.startsWith(prefix))
      );
    }
  });
}

  changeLang(lang: string) {
    this.translationService.setLanguage(lang);
  }

  submitSubscribe(): void {
    // Newsletter not applicable for AFF app
  }
}